import React from 'react';
import { Icon } from './Icon.jsx';

/**
 * v2.0 (A6) — locked-month indicator.
 *
 * Slim persistent ribbon that surfaces under the top bar when the user
 * is viewing a date that falls inside an approved-and-locked month.
 * Must be impossible to miss, but not loud — the goal is "you can read,
 * not edit," not a scolding.
 *
 * Visible to the locked user themselves; the approver drilled-in view
 * doesn't need it (the read-only banner above already explains).
 */
export function LockedRibbon({ month, approvedBy, approvedAt }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 28px',
        background: '#F1F3F5',
        borderBottom: '1px solid var(--sp-border)',
        fontSize: 13,
        color: 'var(--sp-fg-2)',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          width: 22,
          height: 22,
          borderRadius: 6,
          background: '#fff',
          border: '1px solid var(--sp-border)',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--sp-fg-1)',
        }}
      >
        <Icon name="lock" size={12} stroke={2.2} />
      </span>
      <strong style={{ color: 'var(--sp-fg-1)' }}>
        Approved · this month is locked
      </strong>
      <span style={{ color: 'var(--sp-fg-3)' }}>
        · {month}
        {approvedBy ? ` by ${approvedBy}` : ''}
        {approvedAt
          ? ` on ${new Date(approvedAt).toLocaleDateString('en-PH', {
              month: 'short',
              day: 'numeric',
            })}`
          : ''}
      </span>
    </div>
  );
}
